// app/javascript/controllers/loading_state_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["spinner", "success", "saved"]

  connect() {
    // Listen for form submissions anywhere in the document
    document.addEventListener('turbo:submit-start', this.submitStart.bind(this))
    document.addEventListener('turbo:submit-end', this.submitEnd.bind(this))
    
    this.hideSpinner()
    this.hideSuccess()
    this.showSaved()
  }

  disconnect() {
    document.removeEventListener('turbo:submit-start', this.submitStart.bind(this))
    document.removeEventListener('turbo:submit-end', this.submitEnd.bind(this))
  }

  submitStart() {
    this.showSpinner()
    this.hideSuccess()
    this.hideSaved()
  }

  submitEnd() {
    this.hideSpinner()
    this.showSuccess()
    this.hideSaved()
    
    setTimeout(() => {
      this.hideSuccess()
      this.showSaved()
    }, 2000)
  }

  showSpinner() {
    this.spinnerTarget.classList.remove('hidden')
  }

  hideSpinner() {
    this.spinnerTarget.classList.add('hidden')
  }

  showSuccess() {
    this.successTarget.classList.remove('hidden')
  }

  hideSuccess() {
    this.successTarget.classList.add('hidden')
  }

  showSaved() {
    this.savedTarget.classList.remove('hidden')
  }

  hideSaved() {
    this.savedTarget.classList.add('hidden')
  }
}